import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  Tooltip,
  Typography
} from '@material-ui/core';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import MailOutlineIcon from '@material-ui/icons/MailOutline';

import i18n from '../../i18n';

class AvailabilityBoxControl extends Component {
  render() {
    const {
      onWeekendClick,
      includeWeekend,
      isFullTime,
      handleSave,
      handleNextMonth,
      handlePreviousMonth,
      handleSetAllAvailable,
      handleSetAllUnavailable,
      toggleAvailabilityModal,
      canEdit
    } = this.props;

    return (
      <Grid container className="availabilityBoxControl">
        <Grid item xs={1}>
          <IconButton onClick={handlePreviousMonth} className="chevron">
            <ArrowBackIosIcon />
          </IconButton>
        </Grid>
        <Grid item xs={1}>
          <IconButton onClick={handleNextMonth} className="chevron">
            <ArrowForwardIosIcon />
          </IconButton>
        </Grid>
        <Grid item xs={2}>
          <FormControlLabel
            value="start"
            control={
              <Checkbox checked={includeWeekend} onClick={onWeekendClick} />
            }
            label="WEEKEND"
            labelPlacement="start"
          />
        </Grid>
        {canEdit && (
        <Grid item xs={2}>
          <Button
            fullWidth
            variant="contained"
            className="ssenseButton ssensePrimary"
            onClick={handleSetAllAvailable}
          >
            {i18n.t('availability:markAllAvailable')}
          </Button>
        </Grid>
        )}
        {canEdit && (
        <Grid item xs={3}>
          <Button
            fullWidth
            variant="contained"
            className="ssenseButton ssenseDefault"
            onClick={handleSetAllUnavailable}
          >
            {i18n.t('availability:markAllUnavailable')}
          </Button>
        </Grid>
        )}

        <Grid item xs={3}>
          <Grid container>
            {canEdit && (
            <Grid item xs={!isFullTime ? 6 : 8}>
              <Button
                fullWidth
                variant="contained"
                className="ssenseButton ssenseSecondary"
                onClick={handleSave}
              >
                {i18n.t('save')}
              </Button>
            </Grid>
            )}
            {!isFullTime && (
              <Grid item xs={6}>
                <Tooltip title={<Typography>{i18n.t('availability:requestAvailability')}</Typography>}>
                  <Button
                    fullWidth
                    variant="contained"
                    className="mailAvailabilityButton ssensePrimary"
                    onClick={toggleAvailabilityModal}
                  >
                    <MailOutlineIcon />
                  </Button>
                </Tooltip>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

AvailabilityBoxControl.propTypes = {
  includeWeekend: PropTypes.bool.isRequired,
  isFullTime: PropTypes.bool.isRequired,
  onWeekendClick: PropTypes.func.isRequired,
  handleSetAllAvailable: PropTypes.func.isRequired,
  handleSetAllUnavailable: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  handleNextMonth: PropTypes.func.isRequired,
  handlePreviousMonth: PropTypes.func.isRequired,
  toggleAvailabilityModal: PropTypes.func.isRequired,
  canEdit: PropTypes.bool.isRequired,
};

export default AvailabilityBoxControl;
